import { createContext, use, type ReactNode } from 'react';
import { type HorseName } from '../utils/racing-game/consts.ts';
import { type StableName } from '../utils/racing-game/horses';
import { usePreviousGameRoundResults } from '../hooks';

interface PreviousRoundResultsContextType {
  round: number | undefined;
  top3: Array<{
    token: HorseName;
    multiplier: number | null;
  }>;
  winnerGroup: {
    groupName: StableName;
    multiplier: number | null;
  } | null;
}

// TODO: should be properly handled with usePreviousGameRoundResults hook
const PreviousRoundResultsContext =
  createContext<PreviousRoundResultsContextType | null>(null);

export const PreviousRoundResultsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const previousRoundResults = usePreviousGameRoundResults();

  return (
    <PreviousRoundResultsContext value={previousRoundResults}>
      {children}
    </PreviousRoundResultsContext>
  );
};

export const usePreviousRoundResults = () => {
  const context = use(PreviousRoundResultsContext);
  if (!context) {
    throw new Error(
      'usePreviousRoundResults must be used within a PreviousRoundResultsProvider'
    );
  }
  return context;
};
